import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Auth } from '@angular/fire/auth';
import { Firestore, addDoc, collection } from '@angular/fire/firestore';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { AuthService } from '../../core/auth.service';
import { environment } from '../../../environments/environment';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent, ReactiveFormsModule],
    selector: 'app-contact',
    standalone: true,
    styleUrls: ['./contact.page.scss'],
    templateUrl: './contact.page.html',
})
export class ContactPage implements OnInit {
  supportURL: string = environment.supportURL;
  public form: FormGroup;
  id: string = '';  
  thanks: boolean = false;

  constructor(
    private afAuth: Auth, 
    private afs: Firestore,
    public auth: AuthService, 
    private fb: FormBuilder,
    private metaService: Meta,
    private titleService: Title,
  ) {
    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.form = this.fb.group({
      name: ['', Validators.compose([Validators.minLength(2), Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
      message: ['', Validators.compose([Validators.maxLength(255), Validators.required])],
    });
  }

  ngOnInit() {
    this.titleService.setTitle('Contact: gigexchange');
    this.metaService.updateTag({
      name: 'description',
      property: 'og:description',
      content: 'We want to ensure that your gigexchange experience is a good one, please drop us a message.',
    });
    
    this.afAuth.onAuthStateChanged((userAuth: any) => {
      if(userAuth) {
        this.auth.user.subscribe(data => {
          if (data) {
            this.form.patchValue(data);
          }
        })
      }
    })
  }

  save() {
    const email = this.form.value.email;
    const body = this.form.value.message;
    const name = this.form.value.name;
    const msgPayload = {
      from: 'support@gigexchange.com',
      to: 'support@gigexchange.com',
      replyTo: email,
      message: {
        subject: 'Support request from gigexchange',
        text: body,
        html: body,
      },
      sendGrid: {
        templateId: 'd-3a04f859447948679030c2ea95078e7c',
        dynamicTemplateData: {
          message: {
            subject: 'Support request from ' + name,
            text: body,
            html: body,
          }
        }
      }
    };
    
    const docRef = collection(this.afs, 'ge_support');
    addDoc(docRef, { ...this.form.value, ...msgPayload })
      .then(() => {
        this.thanks = true;
      })
      .catch((error: any) => {
        console.error('Error saving message:', error);
      });
  }
}